import { createStore, applyMiddleware, combineReducers } from "redux";
import { routerMiddleware, routerReducer } from "react-router-redux";

import createSagaMiddleware from "redux-saga";

import Raven from "raven-js";
import createRavenMiddleware from "raven-for-redux";
import ReactGA from "react-ga";

import createHistory from "history/createBrowserHistory";

import reducer from "./reducer";
import saga from "./saga";

const history = createHistory();
const sagaMiddleware = createSagaMiddleware();

const middlewares = [routerMiddleware(history), sagaMiddleware];
if (process.env.NODE_ENV === "production") {
  Raven.config("https://6ef42fbb02db4942a507e47404db1a06@sentry.io/1222692").install();
  middlewares.push(createRavenMiddleware(Raven));
}

const store = createStore(
  combineReducers({
    router: routerReducer,
    app: reducer
  }),
  applyMiddleware(...middlewares)
);

//run the root saga
sagaMiddleware.run(saga);

//watch for navigation events
history.listen(location => {
  const url = location.pathname + location.search;
  ReactGA.pageview(url);
});

export { history, store };
